import { Injectable } from '@angular/core';
import { ApiBaseService } from './api.base.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class advanceSearchService extends ApiBaseService {
  constructor(public http: HttpClient) {
    super(http, '/advance-search');
  }

  lastUsedUpdate(body: any,id:any): Observable<any> {
    return this.http.patch(
      `${environment.apiUrl}/advance-search/last_used/${id}`,
      body,
    );
  }

  checkNameExist(name: string, userId?: string): Observable<any> {
    const params = { name };
    const id = userId ? userId : null;
    return this.http.get(`${environment.apiUrl}/advance-search/name/${id}`, {
      params,
    });
  }

  createDefaultValue(body:any){
    return this.http.post(`${environment.apiUrl}/advance-search/createDefaultValue`, body)
  }

  getPinned(params: { entity: string, isPipeline?: boolean }): Observable<any> {
    const apiUrl = `${environment.apiUrl}/advance-search/pinned`;
    
    return this.http.get(apiUrl, {
      params: {
        entity: params.entity,
        isPipeline: params.isPipeline ? 'true' : 'false'
      }
    });
  }
  
  selectPinned(id: number, params?: any): Observable<any> {
    return this.http.put(
      `${environment.apiUrl}/advance-search/pinned/${id}/select`,
      {},
      { params }
    );
  }
  
  deselectPinned(id: number, params?: any): Observable<any> {
    return this.http.put(
      `${environment.apiUrl}/advance-search/pinned/${id}/deselect`,
      {},
      { params }
    );
  }

  reorderPinned(body: { filters: { id: number; sequence: number }[]; isPipeline: boolean }): Observable<any> {
    return this.http.put(
      `${environment.apiUrl}/advance-search/pinned/reorder`,
      body
    );
  }
}
